/* ============================================================
   Den of Sin - interactions (vanilla, reimplemented)
   Wires the custom design to Shopify's AJAX cart + checkout.
   Product/variant data is injected by sections via window.DOS.
   ============================================================ */
(function () {
  'use strict';
  window.DOS = window.DOS || {};
  var DOS = window.DOS;
  DOS.products = DOS.products || []; // [{handle,title,notes,price,mrp,variantId,image,tag}]

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) {
    try { return '₹' + (c / 100).toLocaleString('en-IN'); } catch (e) { return '₹' + (c / 100); }
  };

  /* ---------------- countdown ---------------- */
  function initCountdown() {
    var els = $$('[data-dos-countdown]');
    if (!els.length) return;
    // counts down to next local midnight, then rolls 24h
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var d = Math.max(0, end - now);
      var h = Math.floor(d / 3.6e6), m = Math.floor((d % 3.6e6) / 6e4), s = Math.floor((d % 6e4) / 1e3);
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function (e) { e.textContent = txt; });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- mobile nav ---------------- */
  function initNav() {
    var overlay = $('[data-dos-navoverlay]');
    if (!overlay) return;
    var panel = $('[data-dos-navpanel]', overlay);
    function open() {
      overlay.style.opacity = '1'; overlay.style.pointerEvents = 'auto';
      if (panel) panel.style.transform = 'translateX(0)';
    }
    function close() {
      overlay.style.opacity = '0'; overlay.style.pointerEvents = 'none';
      if (panel) panel.style.transform = 'translateX(100%)';
    }
    $$('[data-dos-navopen]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    $$('[data-dos-navclose]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
  }

  /* ---------------- hero fragrance switcher ---------------- */
  function initSwitcher() {
    var stage = $('[data-dos-hero]');
    if (!stage) return;
    var bottle = $('[data-dos-bottle]', stage);
    var thumbs = $$('[data-dos-thumb]', stage);
    var bar = $('[data-dos-bar]', stage);
    var nameEl = $('[data-dos-pname]', stage);
    var notesEl = $('[data-dos-pnotes]', stage);
    var priceEl = $('[data-dos-pprice]', stage);
    var mrpEl = $('[data-dos-pmrp]', stage);
    var thumbEl = $('[data-dos-cardthumb]', stage);
    var word = $('[data-dos-wordmark]', stage);
    var edge = $('[data-dos-edge]', stage);
    var subEl = $('[data-dos-subtext]', stage);
    var buyEl = $('[data-dos-herobuy]', stage);
    var card = $('[data-dos-card]', stage);
    var viewer = $('[data-dos-tilt]', stage);     // floats up/down
    var glow = $('[data-dos-glow]', stage);
    var shadow = $('[data-dos-shadow]', stage);
    var bardot = $('[data-dos-bardot]', stage);   // glowing dot that sweeps the progress bar

    var DWELL = 3200;          // auto-cycle period (matches the original design)
    var current = -1;

    if (viewer) viewer.style.transition = 'none';  // float is driven per-frame, no lag

    // ---- smoothed mouse parallax for glow/shadow (like the original) ----
    var mx = 0, my = 0, pmx = 0, pmy = 0, t = 0;
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      my = ((e.clientY - r.top) / r.height - 0.5) * 2;
    });
    stage.addEventListener('pointerleave', function () { mx = 0; my = 0; });

    // ---- ONE animation loop on a JS timer (runs wherever the countdown ticks) ----
    var cycleStart = Date.now();
    setInterval(function () {
      t += 0.04;
      var floatY = Math.sin(t * 0.9) * 7;
      if (viewer) viewer.style.transform = 'translateY(' + floatY.toFixed(2) + 'px)';   // bottle float
      pmx += (mx - pmx) * 0.06; pmy += (my - pmy) * 0.06;   // exact smoothing from design
      if (glow) glow.style.transform = 'translate(-50%,-50%) translate(' + (-pmx * 26).toFixed(1) + 'px,' + (-pmy * 20).toFixed(1) + 'px)';
      if (shadow) {
        var lift = (floatY + 7) / 14;
        shadow.style.transform = 'translateX(-50%) scale(' + (1 - lift * 0.12).toFixed(3) + ')';
        shadow.style.opacity = (0.95 - lift * 0.25).toFixed(3);
      }
    }, 40);
    // (progress bar + dot now animate via CSS keyframes - smooth & reliable)

    // ---- text / card / thumbnail updates ----
    function meta(i) {
      var p = DOS.products[i]; if (!p) return;
      if (thumbEl) thumbEl.src = p.image;
      if (nameEl) nameEl.textContent = p.title;
      if (notesEl) notesEl.textContent = p.notes;
      if (priceEl) priceEl.textContent = p.price;
      if (mrpEl) mrpEl.textContent = p.mrp;
      if (word) {                                  // ghost wordmark crossfades to new name
        word.style.transition = 'opacity .4s ease';
        word.style.opacity = '0';
        setTimeout(function () { word.textContent = p.title; word.style.opacity = '1'; }, 220);
      }
      if (edge) {                                  // vertical edge label crossfades too
        edge.style.transition = 'opacity .4s ease';
        edge.style.opacity = '0';
        setTimeout(function () { edge.textContent = '51°30′36.0″N  0°08′02.4″W'; edge.style.opacity = '1'; }, 220);
      }
      if (subEl && p.desc) {
        subEl.style.transition = 'opacity .4s ease';
        subEl.style.opacity = '0';
        setTimeout(function () { subEl.textContent = p.desc; subEl.style.opacity = '1'; }, 220);
      }
      if (buyEl) buyEl.setAttribute('data-dos-variant', p.variantId || '');
      if (card) {
        card.style.transition = 'opacity .22s ease';
        card.style.opacity = '0.2';
        setTimeout(function () { card.style.opacity = '1'; }, 220);
      }
      thumbs.forEach(function (tt, ti) {
        var on = ti === i;
        tt.style.opacity = on ? '1' : '0.5';
        tt.style.borderColor = on ? '#5B7CFF' : 'rgba(255,255,255,0.16)';
        tt.style.background = on ? 'rgba(91,124,255,0.16)' : 'rgba(255,255,255,0.04)';
        tt.style.boxShadow = on ? '0 0 26px rgba(91,124,255,0.6)' : 'none';
        tt.style.transform = on ? 'translateY(-4px) scale(1.1)' : '';   // active pops up; inactive keeps CSS hover
      });
    }

    // ---- switch to the next product (NO rotation, NO spin) - clean crossfade ----
    function switchTo(i, instant) {
      var p = DOS.products[i]; if (!p) return;
      current = i;
      cycleStart = Date.now();
      meta(i);
      // fill the "Select your fragrance" bar over the dwell (same reliable pattern as the bottle slide)
      if (bar) { bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; }
      if (bardot) { bardot.style.transition = 'none'; bardot.style.transform = 'translateX(0)'; }
      setTimeout(function () {
        if (bar) { bar.style.transition = 'transform ' + DWELL + 'ms linear'; bar.style.transform = 'scaleX(1)'; }
        if (bardot) { bardot.style.transition = 'transform ' + DWELL + 'ms linear'; bardot.style.transform = 'translateX(160px)'; }
      }, 50);
      if (!bottle) return;
      if (instant) { bottle.src = p.image; bottle.style.opacity = '1'; bottle.style.transform = 'translateX(0)'; return; }
      // next product slides in lightly FROM THE RIGHT (no rotation)
      bottle.style.transition = 'opacity .35s ease, transform .4s cubic-bezier(.4,0,.2,1)';
      bottle.style.opacity = '0';
      bottle.style.transform = 'translateX(-30px)';      // current drifts left & fades out
      setTimeout(function () {
        bottle.src = p.image;
        bottle.style.transition = 'none';
        bottle.style.transform = 'translateX(70px)';     // next starts off to the right
        void bottle.offsetWidth;
        bottle.style.transition = 'opacity .55s ease, transform .7s cubic-bezier(.22,.61,.36,1)';
        bottle.style.opacity = '1';
        bottle.style.transform = 'translateX(0)';         // glides in to center
      }, 380);
    }

    thumbs.forEach(function (tt, i) { tt.addEventListener('click', function () { switchTo(i); }); });

    switchTo(0, true);                              // first product shown instantly
    setInterval(function () { switchTo((current + 1) % DOS.products.length); }, DWELL);
  }

  /* ---------------- feature carousel ---------------- */
  function initCarousel() {
    $$('[data-dos-carousel]').forEach(function (root) {
      var track = $('[data-dos-track]', root);
      if (!track) return;
      var slides = track.children.length;
      var idx = 0;
      function go(n) { idx = (n + slides) % slides; track.style.transform = 'translateX(-' + (idx * 100) + '%)'; }
      var scope = root.closest('section') || document;
      var prev = $('[data-dos-prev]', scope), next = $('[data-dos-next]', scope);
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      go(0);
    });
  }

  /* ---------------- FAQ accordion ---------------- */
  function initAccordion() {
    $$('[data-dos-acc]').forEach(function (item) {
      var btn = $('[data-dos-acc-q]', item);
      var body = $('[data-dos-acc-a]', item);
      if (!btn || !body) return;
      body.style.overflow = 'hidden'; body.style.maxHeight = '0px';
      body.style.transition = 'max-height .35s ease';
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === '1';
        item.setAttribute('data-open', open ? '0' : '1');
        body.style.maxHeight = open ? '0px' : body.scrollHeight + 'px';
        var ic = $('[data-dos-acc-icon]', item); if (ic) ic.style.transform = open ? 'rotate(0deg)' : 'rotate(45deg)';
      });
    });
  }

  /* ---------------- Shopify cart drawer ---------------- */
  function initCart() {
    var drawer = $('[data-dos-cartdrawer]');
    function openDrawer() { if (drawer) { drawer.style.opacity = '1'; drawer.style.pointerEvents = 'auto'; var p = $('[data-dos-cartpanel]', drawer); if (p) p.style.transform = 'translateX(0)'; } }
    function closeDrawer() { if (drawer) { drawer.style.opacity = '0'; drawer.style.pointerEvents = 'none'; var p = $('[data-dos-cartpanel]', drawer); if (p) p.style.transform = 'translateX(100%)'; } }
    DOS.openCart = openDrawer; DOS.closeCart = closeDrawer;

    $$('[data-dos-cartopen]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); render(); }); });
    $$('[data-dos-cartclose]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); }); });

    function setBadge(count) { $$('[data-dos-cartcount]').forEach(function (e) { e.textContent = count; e.style.display = count > 0 ? '' : 'none'; }); }

    var stickyClosed = false;
    var lastVariant = null;
    var sticky = $('[data-dos-sticky]');
    var sbar = $('[data-dos-sbar]');
    $$('[data-dos-sticky-close]').forEach(function (b) { b.addEventListener('click', function () { stickyClosed = true; if (sticky) sticky.style.transform = 'translateY(160%)'; }); });

    // sticky bar qty stepper - adjusts the last-added product
    function stickyAdjust(delta) {
      if (!lastVariant) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var line = null;
        for (var i = 0; i < cart.items.length; i++) { if (String(cart.items[i].variant_id) === String(lastVariant)) { line = cart.items[i]; break; } }
        if (!line) { render(); return; }
        var next = Math.max(0, line.quantity + delta);
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: next }) })
          .then(function (r) { return r.json(); }).then(function () { render(); });
      });
    }
    $$('[data-dos-sticky-inc]').forEach(function (b) { b.addEventListener('click', function () { stickyAdjust(1); }); });
    $$('[data-dos-sticky-dec]').forEach(function (b) { b.addEventListener('click', function () { stickyAdjust(-1); }); });

    function pulseSticky() { if (!sbar) return; sbar.style.animation = 'none'; void sbar.offsetWidth; sbar.style.animation = 'dosPop .42s cubic-bezier(.34,1.56,.64,1)'; }

    function updateSticky(cart) {
      if (!sticky) return;
      var show = cart.item_count > 0 && !stickyClosed;
      sticky.style.transform = show ? 'translateY(0)' : 'translateY(160%)';
      var c = $('[data-dos-sticky-count]'); if (c) c.textContent = cart.item_count + (cart.item_count === 1 ? ' item in cart' : ' items in cart');
      var t = $('[data-dos-sticky-total]'); if (t) t.textContent = money(cart.total_price);
      if (!lastVariant && cart.items.length) lastVariant = cart.items[cart.items.length - 1].variant_id;
      var lastQty = 0;
      for (var i = 0; i < cart.items.length; i++) { if (String(cart.items[i].variant_id) === String(lastVariant)) { lastQty = cart.items[i].quantity; break; } }
      var q = $('[data-dos-sticky-qty]'); if (q) q.textContent = lastQty || cart.item_count;
      var chips = $('[data-dos-sticky-chips]');
      if (chips) {
        chips.innerHTML = cart.items.slice(0, 4).map(function (it, k) {
          var badge = it.quantity > 1 ? '<span style="position:absolute;top:-6px;right:-6px;min-width:15px;height:15px;padding:0 3px;background:#3C62FF;border-radius:999px;color:#fff;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;box-shadow:0 0 0 2px rgba(0,26,140,0.98);font-family:Inter,sans-serif;">×' + it.quantity + '</span>' : '';
          return '<div style="position:relative;width:30px;height:36px;border-radius:6px;background:linear-gradient(160deg,#EEF3FF,#DDE7FF);flex:none;display:flex;align-items:flex-end;justify-content:center;overflow:visible;margin-left:' + (k === 0 ? '0' : '-8px') + ';box-shadow:0 0 0 2px rgba(0,26,140,0.98);"><img src="' + (it.image || '') + '" alt="" style="height:86%;width:auto;object-fit:contain;border-radius:6px;" />' + badge + '</div>';
        }).join('');
      }
    }

    function render() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setBadge(cart.item_count);
          var list = $('[data-dos-cartitems]'); if (!list) return;
          if (!cart.items.length) { list.innerHTML = '<div style="padding:40px 8px;text-align:center;color:#8A8F9C;font-size:14px;">Your cart is empty.</div>'; }
          else {
            list.innerHTML = cart.items.map(function (it) {
              var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div style="font-family:Inter,sans-serif;font-size:12px;color:#9AA0AD;margin-top:2px;">' + it.variant_title + '</div>' : '';
              return '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid #F0F2F7;align-items:flex-start;">' +
                '<img src="' + (it.image || '') + '" alt="" style="width:74px;height:74px;object-fit:cover;border-radius:12px;background:#EEF3FF;flex:none;" />' +
                '<div style="flex:1;min-width:0;">' +
                  '<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;">' +
                    '<div style="font-family:Inter,sans-serif;font-weight:600;font-size:14px;color:#0B0C12;line-height:1.3;">' + it.product_title + '</div>' +
                    '<button data-dos-remove data-key="' + it.key + '" aria-label="Remove" style="background:none;border:none;color:#C2C7D2;cursor:pointer;font-size:16px;line-height:1;flex:none;padding:0;">&times;</button>' +
                  '</div>' + vt +
                  '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px;">' +
                    '<div style="display:inline-flex;align-items:center;border:1px solid #E2E6F0;border-radius:999px;overflow:hidden;">' +
                      '<button data-dos-qty="dec" data-key="' + it.key + '" style="width:30px;height:30px;border:none;background:#fff;color:#001E99;cursor:pointer;font-size:16px;line-height:1;">−</button>' +
                      '<span style="min-width:28px;text-align:center;font-size:13px;font-weight:700;color:#0B0C12;">' + it.quantity + '</span>' +
                      '<button data-dos-qty="inc" data-key="' + it.key + '" style="width:30px;height:30px;border:none;background:#fff;color:#001E99;cursor:pointer;font-size:15px;line-height:1;">+</button>' +
                    '</div>' +
                    '<div style="font-family:Inter,sans-serif;font-weight:800;font-size:15px;color:#001E99;">' + money(it.final_line_price) + '</div>' +
                  '</div>' +
                '</div>' +
                '</div>';
            }).join('');
          }
          var sub = $('[data-dos-cartsubtotal]'); if (sub) sub.textContent = money(cart.total_price);
          var fs = $('[data-dos-freeship]'); if (fs) fs.style.display = cart.total_price >= 199900 ? 'flex' : 'none';
          updateSticky(cart);
          bindRows();
        });
    }
    function change(key, qty) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function () { render(); });
    }
    function bindRows() {
      $$('[data-dos-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-key');
          var row = b.closest('[style*="border-bottom"]');
          var span = row ? row.querySelector('span') : null;
          var cur = span ? parseInt(span.textContent, 10) : 1;
          change(key, b.getAttribute('data-dos-qty') === 'inc' ? cur + 1 : Math.max(0, cur - 1));
        });
      });
      $$('[data-dos-remove]').forEach(function (b) { b.addEventListener('click', function () { change(b.getAttribute('data-key'), 0); }); });
    }

    // add to cart (any element with data-dos-add or data-dos-variant + buy intent)
    function add(variantId, qty, mode) {
      if (!variantId) { window.location.href = '/cart'; return; }
      lastVariant = variantId;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty || 1 }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          stickyClosed = false;
          if (mode === 'checkout') { window.location.href = '/checkout'; return; }   // Buy now → straight to checkout
          else { render(); pulseSticky(); }                    // Add to cart → black bottom bar
        })
        .catch(function () { window.location.href = '/cart'; });
    }
    DOS.add = add;

    // quantity steppers (product grid)
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-dos-step]');
      if (!step) return;
      e.preventDefault();
      var card = step.closest('[data-dos-card]') || document;
      var field = card.querySelector('[data-dos-qtyval]');
      if (!field) return;
      var cur = parseInt(field.textContent, 10) || 1;
      cur = step.getAttribute('data-dos-step') === 'inc' ? cur + 1 : Math.max(1, cur - 1);
      field.textContent = cur;
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-dos-add],[data-dos-herobuy]');
      if (!t) return;
      e.preventDefault();
      var qty = 1;
      var card = t.closest('[data-dos-card]');
      if (card) { var f = card.querySelector('[data-dos-qtyval]'); if (f) qty = parseInt(f.textContent, 10) || 1; }
      else if (t.hasAttribute('data-dos-pdp-add')) { var pf = document.querySelector('#dos-buy [data-dos-qtyval]'); if (pf) qty = parseInt(pf.textContent, 10) || 1; }   // product page quantity box
      var mode = t.hasAttribute('data-dos-buynow') ? 'checkout' : 'cart';
      add(t.getAttribute('data-dos-variant') || t.getAttribute('data-dos-add'), qty, mode);
    });

    render(); // initial badge
  }

  /* ---------------- Favourites / wishlist (localStorage) ---------------- */
  function initFavs() {
    var KEY = 'dos_favs';
    function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
    function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
    function count() { return Object.keys(get()).length; }
    function isFav(h) { return !!get()[h]; }
    function heart(f) {
      return f
        ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="#FF3D6E" stroke="#FF3D6E" stroke-width="1.5"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l8.8 8.8 8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/></svg>'
        : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l8.8 8.8 8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/></svg>';
    }
    function updateUI() {
      var n = count();
      $$('[data-dos-fav-count]').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none'; });
      $$('[data-dos-fav]').forEach(function (btn) {
        var f = isFav(btn.getAttribute('data-fav-handle'));
        var ic = btn.querySelector('[data-fav-icon]'); if (ic) ic.innerHTML = heart(f);
        if (f) btn.classList.add('is-fav'); else btn.classList.remove('is-fav');
        btn.setAttribute('aria-pressed', f ? 'true' : 'false');
      });
    }
    function toggle(btn) {
      var h = btn.getAttribute('data-fav-handle'); if (!h) return;
      var o = get();
      if (o[h]) { delete o[h]; }
      else {
        o[h] = { handle: h, title: btn.getAttribute('data-fav-title') || '', price: btn.getAttribute('data-fav-price') || '',
          compare: btn.getAttribute('data-fav-compare') || '', img: btn.getAttribute('data-fav-img') || '',
          url: btn.getAttribute('data-fav-url') || '#', variant: btn.getAttribute('data-fav-variant') || '' };
      }
      save(o); updateUI(); renderList();
    }
    function renderList() {
      var wrap = $('[data-dos-fav-list]'); if (!wrap) return;
      var o = get(), keys = Object.keys(o), empty = $('[data-dos-fav-empty]');
      if (!keys.length) { wrap.innerHTML = ''; if (empty) empty.style.display = 'block'; return; }
      if (empty) empty.style.display = 'none';
      wrap.innerHTML = keys.map(function (h) {
        var p = o[h];
        var cmp = p.compare ? '<span style="font-size:14px;color:#B6BBC6;text-decoration:line-through;margin-left:7px;">' + p.compare + '</span>' : '';
        return '<article style="background:#fff;border:1px solid #EEF1F7;border-radius:22px;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 12px 36px rgba(20,40,120,0.06);">'
          + '<a href="' + p.url + '" style="position:relative;height:240px;background:radial-gradient(130% 100% at 50% 0%, #E7EFFF 0%, #F3F8FF 56%, #ffffff 100%);display:flex;align-items:center;justify-content:center;overflow:hidden;">'
          + '<img src="' + p.img + '" alt="' + p.title + '" style="height:82%;width:auto;object-fit:contain;filter:drop-shadow(0 20px 32px rgba(0,20,80,0.20));"/></a>'
          + '<div style="padding:18px 20px 22px;display:flex;flex-direction:column;flex:1;">'
          + '<a href="' + p.url + '" style="text-decoration:none;"><h3 class="dos-link-blue" style="font-family:Inter,sans-serif;font-weight:600;font-size:17px;color:#0B0C12;margin:0 0 8px;">' + p.title + '</h3></a>'
          + '<div style="margin:0 0 16px;"><span style="font-family:Inter,sans-serif;font-weight:800;font-size:20px;color:#001E99;">' + p.price + '</span>' + cmp + '</div>'
          + '<div style="display:flex;gap:9px;margin-top:auto;">'
          + '<button type="button" data-dos-add="' + p.variant + '" class="dos-btn-outline" style="flex:1;display:inline-flex;align-items:center;justify-content:center;background:#fff;color:#001E99;border:1.5px solid #C9D4F5;font-family:Inter,sans-serif;font-weight:600;font-size:13px;padding:12px;border-radius:999px;cursor:pointer;">Add to cart</button>'
          + '<button type="button" data-dos-fav-remove="' + h + '" aria-label="Remove" style="flex:none;width:44px;border:1.5px solid #F2D6DD;background:#fff;color:#FF3D6E;border-radius:999px;cursor:pointer;font-size:17px;line-height:1;">&times;</button>'
          + '</div></div></article>';
      }).join('');
    }
    document.addEventListener('click', function (e) {
      var fav = e.target.closest('[data-dos-fav]');
      if (fav) { e.preventDefault(); e.stopPropagation(); toggle(fav); return; }
      var rm = e.target.closest('[data-dos-fav-remove]');
      if (rm) { e.preventDefault(); var o = get(); delete o[rm.getAttribute('data-dos-fav-remove')]; save(o); updateUI(); renderList(); }
    });
    updateUI(); renderList();
  }

  /* ---------------- 3D unbox reveal trigger ---------------- */
  function initUnbox() {
    var stages = $$('.dos-unbox-stage');
    if (!stages.length) return;
    if (!('IntersectionObserver' in window)) { stages.forEach(function (s) { s.classList.add('in-view'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } });
    }, { threshold: 0.3 });
    stages.forEach(function (s) { io.observe(s); });
  }

  function boot() {
    initCountdown(); initNav(); initSwitcher(); initCarousel(); initAccordion(); initCart(); initFavs(); initUnbox();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
